module.exports = __webpack_public_path__ + "img/horizontal_3_1_pp1_5012.6a295821.png";